export const Conversation = `
conversationId
createdBy
type
start
end
status
participants {
  user {
    userId
    profile {
      phoneNumber
      firstName
      middleName
      dateOfBirth
      lastName
      title
      gender
      avatar
      isVerified
      isTosAccepted
      isIdEligible
      changePasswordRequired
      policyId
    }
  }
  participantType
  userAvailability {
    status
  }
}
statusHistory {
  status
  createdAt
}
call {
  callDeadLineTimestamp
  callerName
}
updatedAt
initiator
`;
